module.exports = "<svg  height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 407.44 407.44\"><path d=\"M315.87 21.18L294.62 0 91.57 203.72l203.05 203.72 21.25-21.18-181.95-182.54\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/chevron-left.svg
// module id = ./src/icons/chevron-left.svg
// module chunks = 21